import React from "react";
import MaterialIcon from "../../../../shared/components/MaterialIcon";
import { useTranslation } from "../../../../i18n";

export { MaterialIcon };

export function CheckoutLabel({ htmlFor, children }) {
  return (
    <label
      htmlFor={htmlFor}
      className="font-label-caps text-label-caps text-on-surface"
    >
      {children}
    </label>
  );
}

export function CheckoutSubmitButton({
  children,
  submitting = false,
  disabled = false,
  type = "submit",
  onClick,
}) {
  const { t } = useTranslation();

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled || submitting}
      className="architect-gradient flex w-full transform items-center justify-center gap-3 rounded-xl py-5 font-headline-md text-white shadow-active transition-all hover:opacity-90 active:scale-[0.98] disabled:cursor-not-allowed disabled:opacity-70"
    >
      {submitting ? (
        <>
          <MaterialIcon name="refresh" className="animate-spin text-[20px]" />
          {t("payment.processing")}
        </>
      ) : (
        children
      )}
    </button>
  );
}

export function CheckoutInfoBox({ children }) {
  return (
    <div className="flex items-start gap-3 rounded-lg bg-surface p-4">
      <MaterialIcon name="info" className="text-[20px] text-on-surface-variant" />
      <p className="text-label-sm text-on-surface-variant">{children}</p>
    </div>
  );
}
